<template>
  <div id="app" class="bg-light">
    <transition name="fade">
      <StartAnimation v-if="isLoading" @loaded="showPage" />
    </transition>
    <transition name="fade">
      <navbar v-show="!isLoading"/>
    </transition>
    <transition name="fade">
      <main role="main" v-show="!isLoading">
        <Introduction/>
        <About/>
        <Projects/>
        <Technologies/>
        <Contact/>
      </main>
    </transition>
    <transition name="fade">
      <JFooter v-show="!isLoading"/>
    </transition>
    <BackToTop v-show="!isLoading"/>
  </div>
</template>

<script>
import Navbar from './components/Layout/Navbar.vue'
import StartAnimation from './components/Layout/StartAnimation.vue'
import About from './components/About.vue'
import Introduction from './components/Introduction.vue'
import Technologies from './components/Technologies.vue'
import Projects from './components/Projects.vue'
import Contact from './components/Contact.vue'
import JFooter from './components/Layout/JFooter.vue'
import BackToTop from './components/Tools/BackToTop.vue'

export default {
  name: 'app',
  data: () => ({
    isLoading: true
  }),
  components: {
    StartAnimation, About, Introduction, Navbar, Projects, Technologies, Contact, JFooter, BackToTop
  },
  methods: {
    showPage () {
      this.isLoading = false
    }
  }
}
</script>

<style>
@import url('assets/stylesheets/custom.css');

#app {
  width: 100%;
  min-height: 100vh;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .8s linear;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
